import React, { useEffect, useRef, useState } from "react";
import { jakusci, left_arrow, no_image, pool, tub } from "../../assets/imgs";
import CancelIcon from "@mui/icons-material/Cancel";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import SelectBox from "../SelectBox";
import SelectBoxImg from "../SelectBoxImg";
import { useAmenitiesListMutation, useLazyPropertyAmenitiesListQuery, useMinimumAgeMutation, usePropertyRoomDetailsAddMutation } from "../../screens/redux/api/api";
import { toast } from "react-toastify";
import { configJodit } from "../../screens/redux/api/Constants";

const PropertyRoomsAdd = ({ setTabs, property_id, owner_id }) => {
  const [value, setValue] = useState();
  const navigate = useNavigate();
  const editor = useRef([]);
  const [content, setContent] = useState("");
  const [images, setImages] = useState([]);
  const imgRef = useRef([]);
  const [image, setImage] = useState("");
  const [popup, setPopup] = useState(false);
  const [roomCat, setRoomCat] = useState([])
  const prop_id = property_id
  const [loading, setLoading] = useState(false)
  const [selectedRoomCats, setSelectedRoomCats] = useState([]);

  const [amiList, setAmiList] = useState([])
  const [draggedItem, setDraggedItem] = useState(null);

  console.log('property_id', prop_id)

  //RTK
  const [minimumAgeListApi] = useMinimumAgeMutation()
  const [aminitiesListApi] = useLazyPropertyAmenitiesListQuery()
  // const [aminitiesListApi] = useAmenitiesListMutation()
  const [roomsAddApi] = usePropertyRoomDetailsAddMutation()


  const addRoomsFunc = async () => {
    // Check if there are any rooms
    if (!newRooms || newRooms.length === 0) {
      toast.error("Please add at least one room");
      return false;
    }

    // Validate each room
    for (let i = 0; i < newRooms.length; i++) {
      const room = newRooms[i];
      const roomNumber = i + 1;

      // Room Category validation
      if (!room.room_category) {
        toast.error(`Room ${roomNumber}: Please select a room category`);
        return false;
      }

      // Number of Rooms validation
      if (!room.no_of_room || isNaN(room.no_of_room) || room.no_of_room <= 0) {
        toast.error(`Room ${roomNumber}: Please enter a valid number of rooms (must be greater than 0)`);
        return false;
      }

      // Amenities validation
      if (!room.amenities || room.amenities.length === 0) {
        toast.error(`Room ${roomNumber}: Please select at least one amenity`);
        return false;
      }

      // Daily Pricing validation
      const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      for (const day of days) {
        const price = room.price_per_day?.[day];
        if (price === undefined || price === null || price === "" || isNaN(price) || price <= 0) {
          toast.error(`Room ${roomNumber}: Please enter a valid price for ${day.charAt(0).toUpperCase() + day.slice(1)}`);
          return false;
        }
      }

      // Person Count validation
      // if (!room.total_person_count || isNaN(room.total_person_count)) {
      //   toast.error(`Room ${roomNumber}: Please enter a valid total person count`);
      //   return false;
      // }

      if (!room.extra_person_count === undefined || isNaN(room.extra_person_count)) {
        toast.error(`Room ${roomNumber}: Please enter a valid extra person count`);
        return false;
      }

      if (room.extra_charges_per_person === undefined || room.extra_charges_per_person === null || isNaN(room.extra_charges_per_person)) {
        toast.error(`Room ${roomNumber}: Please enter valid extra charges per person`);
        return false;
      }

      // Description validation
      if (!room.description || room.description.trim() === "") {
        toast.error(`Room ${roomNumber}: Please enter a description`);
        return false;
      }

      // // Images validation
      if (!room.images || room.images.length === 0) {
        toast.error(`Room ${roomNumber}: Please upload at least one image`);
        return false;
      }

      if (room.images.length > 10) {
        toast.error(`Room ${roomNumber}: Maximum 10 images allowed`);
        return false;
      }
    }

    // return true;

    setLoading(true);
    try {
      const formData = new FormData();

      // Add property_id
      formData.append('property_id', prop_id.toString());
      formData.append('room_id', null);

      // Add rooms data
      newRooms.forEach((room, roomIndex) => {
        // Room metadata
        formData.append(`rooms[${roomIndex}][room_category_id]`, room.room_category.toString());
        formData.append(`rooms[${roomIndex}][no_of_rooms]`, room.no_of_room.toString());

        // Amenities
        room.amenities.forEach((amenity, amenityIndex) => {
          formData.append(`rooms[${roomIndex}][amenity_ids][${amenityIndex}]`, amenity.id.toString());
        });

        // Prices
        formData.append(`rooms[${roomIndex}][prices][mon_price]`, (room.price_per_day.monday).toString());
        formData.append(`rooms[${roomIndex}][prices][tue_price]`, (room.price_per_day.tuesday).toString());
        formData.append(`rooms[${roomIndex}][prices][wed_price]`, (room.price_per_day.wednesday).toString());
        formData.append(`rooms[${roomIndex}][prices][thu_price]`, (room.price_per_day.thursday).toString());
        formData.append(`rooms[${roomIndex}][prices][fri_price]`, (room.price_per_day.friday).toString());
        formData.append(`rooms[${roomIndex}][prices][sat_price]`, (room.price_per_day.saturday).toString());
        formData.append(`rooms[${roomIndex}][prices][sun_price]`, (room.price_per_day.sunday).toString());
        formData.append(`rooms[${roomIndex}][prices][total_persons]`, (room.total_person_count).toString());
        formData.append(`rooms[${roomIndex}][prices][additional_persons]`, (room.extra_person_count).toString());
        formData.append(`rooms[${roomIndex}][prices][extra_charge_per_person]`, (room.extra_charges_per_person).toString());

        // Description
        formData.append(`rooms[${roomIndex}][description]`, room.description);

        // Property images with file objects
        room.images.forEach((image, imageIndex) => {
          formData.append(`rooms[${roomIndex}][property_images][${imageIndex}][position]`, (imageIndex + 1).toString());
          formData.append(`rooms[${roomIndex}][property_images][${imageIndex}][image]`, image);
        });
      });

      // Call the API
      const res = await roomsAddApi(formData).unwrap();
      console.log('API Response:', res);
      toast.success(res?.mesaage || "Rooms added successfully!");
      // navigate('/property')
      navigate("/property-approve-view", {
        state: {
          tab: 6,
          owner_id: owner_id,
          property_id: property_id,
        }
      })
    } catch (err) {
      console.error('API Error:', err);
      toast.error(err?.message || "Failed to add rooms");
    } finally {
      setLoading(false);
    }
  };


  const getAgeLsit = (type) => {
    let formdata = new FormData()
    formdata.append('type', type)
    minimumAgeListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log('res', res)
        setRoomCat(res?.categories)
      }).catch((err) => {
        console.log('err', err)
      })
  }

  const getAminitiesList = () => {
    let formdata = new FormData()
    formdata.append('pagination', 0)
    aminitiesListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log('res-ami', res)
        setAmiList(res?.amenities)
      }).catch((err) => {
        console.error('err-ami', err)
      })
  }

  useEffect(() => {
    getAgeLsit(1)
    getAminitiesList()
  }, [])


  const [newRooms, setNewRooms] = useState([
    {
      room_category: "",
      no_of_room: "",
      amenities: [],
      price_per_day: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
      total_person_count: "",
      extra_person_count: "",
      extra_charges_per_person: "",
      description: "",
      images: [],
    },
  ]);

  const showImgPopup = (item) => {
    setImage(item);
    setPopup(true);
  };

  const handleImages = (event) => {
    const files = event.target.files;
    if (files) {
      const filesArray = Array.from(files);

      // Check if adding these files will exceed the limit of 10
      if (images.length + filesArray.length > 10) {
        alert("You can only upload a maximum of 10 images.");
        return;
      }

      // Add new files to the existing images
      setImages((prevImages) => [...prevImages, ...filesArray]);
    }
  };

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  // const users = [
  //   { id: 1, name: "Jakusci", age: 28, city: "New York" },
  //   { id: 2, name: "Hotub", age: 34, city: "Los Angeles" },
  //   { id: 3, name: "Balcani Swimming Pool", age: 22, city: "Chicago" },
  //   { id: 4, name: "Hotub1", age: 25, city: "Miami" },
  //   { id: 5, name: "Jakusci2", age: 40, city: "San Francisco" },
  //   { id: 6, name: "Balcani Swimming Pool2", age: 22, city: "Chicago" },
  // ];

  const [userName, setUserName] = useState([]);
  const [userID, setUserID] = useState([]);
  const [validation, setValidation] = useState("");

  // Drag and drop handlers
  const handleDragStart = (e, roomIndex, imageIndex) => {
    setDraggedItem({ roomIndex, imageIndex });
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.currentTarget);
  };

  const handleDragOver = (e, roomIndex, imageIndex) => {
    e.preventDefault();
    if (!draggedItem ||
      (draggedItem.roomIndex === roomIndex && draggedItem.imageIndex === imageIndex)) {
      return;
    }

    // Calculate the new position
    const newIndex = imageIndex;
    const oldIndex = draggedItem.imageIndex;

    if (newIndex === oldIndex) return;

    setNewRooms(prevRooms => {
      const updatedRooms = [...prevRooms];
      const room = { ...updatedRooms[roomIndex] };
      const images = [...room.images];

      // Remove the dragged item from its old position
      const [removed] = images.splice(oldIndex, 1);
      // Insert it at the new position
      images.splice(newIndex, 0, removed);

      // Update the room with the new images array
      updatedRooms[roomIndex] = {
        ...room,
        images: images
      };

      // Update the draggedItem position
      setDraggedItem({
        roomIndex,
        imageIndex: newIndex
      });

      return updatedRooms;
    });
  };

  const handleDrop = (e, roomIndex, imageIndex) => {
    e.preventDefault();
    setDraggedItem(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };


  const handleChange = (event, ind, type, type_2) => {
    console.log("eent", event, ind, type, type_2)
    let temp = [...newRooms];
    let obj = { ...temp[ind] };
    if (type_2) {
      obj.price_per_day[type_2] = event;
    } else {
      if (type == "images") {
        const files = event.target.files;
        if (files) {
          const filesArray = Array.from(files);

          // Check if adding these files will exceed the limit of 10
          if (obj?.images?.length + filesArray.length > 10) {
            toast.error("You can only upload a maximum of 10 images.");
            return;
          }

          // Add new files to the existing images
          obj[type] = [...obj[type], ...filesArray];
        }
      } else {
        obj[type] = event;
      }
    }
    temp[ind] = obj;
    console.log(temp, "temp var")
    setNewRooms(temp);
  };

  const removeAmenities = (ind, inds) => {
    let full_arr = [...newRooms];
    let full_arr_ = [...full_arr[ind].amenities];
    full_arr_.splice(inds, 1);
    full_arr[ind]["amenities"] = full_arr_;
    setNewRooms(full_arr);
  };

  const newRoomRemoveImage = (ind, indImg) => {
    let full_arr = [...newRooms];
    let full_arr_ = [...full_arr[ind].images];
    full_arr_.splice(indImg, 1);
    full_arr[ind]["images"] = full_arr_;
    setNewRooms(full_arr);
  };

  const addNewRoom = () => {
    let temp = [...newRooms];
    temp.push({
      room_category: "",
      no_of_room: "",
      amenities: [],
      price_per_day: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
      total_person_count: "",
      extra_person_count: "",
      extra_charges_per_person: "",
      description: "",
      images: [],
    });
    setNewRooms(temp);
  };

  const removeRooms = (ind) => {
    setNewRooms(prevRooms => {
      const updatedRooms = [...prevRooms];
      const removedRoom = updatedRooms.splice(ind, 1);
      if (removedRoom[0]?.room_category) {
        setSelectedRoomCats(prev =>
          prev.filter(catId => catId !== removedRoom[0].room_category)
        );
      }
      return updatedRooms;
    });
  }

  console.log(newRooms, "new rooms")

  return (
    <div className=" mt-2">
      <div className="d-flex ac-js">
        <div className="d-flex ac-js pointer gap-2">
          <img
            src={left_arrow}
            className="leftArrow mb-3 pointer"
            onClick={() => setTabs(2)}
          />
          <p
            className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
            onClick={() => setTabs(2)}
          >
            Back
          </p>
        </div>

      </div>
      {newRooms?.map((item, ind) => {
        return (
          <div key={ind}>
            {ind > 0 && (<div
              className="d-flex ac-je"
              onClick={() => removeRooms(ind)}>
              <CancelIcon />
            </div>)}
            <div className="d-flex gap-5 mb-4">
              <div className="col-md-5">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Room Category
                </h4>
                <select
                  className="input-pop ps-2 w-100"
                  value={item?.room_category}
                  onChange={(e) => {
                    const newValue = Number(e.target.value);
                    handleChange(newValue, ind, "room_category");
                    setSelectedRoomCats(prev => [...prev, newValue]);
                  }}
                >
                  <option value={""}>Select</option>
                  {roomCat
                    ?.filter(cat => !selectedRoomCats.includes(cat.id) || cat.id === item?.room_category)
                    ?.map((item, ind) => (
                      <option key={Number(item?.id)} value={item?.id}>
                        {item?.name}
                      </option>
                    ))
                  }
                </select>
              </div>
              <div className="col-md-5">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  No of Rooms
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="No of Rooms"
                  value={item?.no_of_room}
                  onChange={(e) =>
                    handleChange(e.target.value, ind, "no_of_room")
                  }
                />
              </div>
            </div>
            <div className="col-md-12">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Amenities
              </h4>
              <div className="col-md-5">
                <SelectBoxImg
                  array_list={amiList} // array
                  value_text={item?.amenities} // array
                  setvalue_text={setUserName} // array
                  setValidation={setValidation} // string 
                  isMulti={true} // boolean
                  isTextArea={false} // boolean
                  types={"room"}
                  ind={ind}
                  key_name={"amenities"}
                  handleChange={handleChange}
                />
              </div>
              <div className="d-flex align-items-center flex-wrap gap-4 mt-4">
                {item?.amenities?.map((amenity, index) => {
                  return (
                    <div
                      className="d-flex ac-jc gap-1 p-2 input-pop mb-3 position-relative"
                      key={index}
                    >
                      <img
                        src={amenity?.image_url || tub}
                        className="tub-img"

                      />
                      <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                        {amenity?.name}
                      </p>
                      <div onClick={() => removeAmenities(ind, index)}>
                        <CancelIcon
                          className="red pointer"
                          style={{
                            position: "absolute",
                            top: "-7px",
                            right: "-7px",
                            width: "15px",
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-4">
              Pricing Per Day
            </h4>
            <div className="input-pop_box">
              <table className="w-100">
                <thead>
                  <tr className="text-center">
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                    <th>Sunday</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.monday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "monday"
                          )
                        }
                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.tuesday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "tuesday"
                          )
                        }

                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.wednesday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "wednesday"
                          )
                        }
                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.thursday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "thursday"
                          )
                        }
                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.friday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "friday"
                          )
                        }
                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.saturday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "saturday"
                          )
                        }
                      />
                    </td>
                    <td className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        placeholder="Enter Amount"
                        type="number"
                        min={0}
                        maxLength={5}
                        value={item?.price_per_day?.sunday}
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            ind,
                            "price_per_day",
                            "sunday"
                          )
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="d-flex flex-wrap ac-jb my-5">
              <div className="col-md-3">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Total Person Count
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Total Person Count"
                  value={item?.total_person_count}
                  onChange={(e) =>
                    handleChange(e.target.value, ind, "total_person_count")
                  }
                />
              </div>
              <div className="col-md-3">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Extra Person Count
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Extra Person Count"
                  value={item?.extra_person_count}
                  onChange={(e) =>
                    handleChange(e.target.value, ind, "extra_person_count")
                  }
                />
              </div>
              <div className="col-md-3">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Extra Charges Per Person
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Extra Charges Per Person"
                  value={item?.extra_charges_per_person}
                  onChange={(e) =>
                    handleChange(
                      e.target.value,
                      ind,
                      "extra_charges_per_person"
                    )
                  }
                />
              </div>
            </div>
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              Description
            </h4>
            <JoditEditor
              style={{ border: "1px solid #0C3A2D" }}
              className="input-pop w-100"
              ref={(el) => (editor.current[ind] = el)}
              value={item?.description}
              onBlur={(newContent) =>
                handleChange(newContent, ind, "description")
              }
              config={configJodit}

            />
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              Choose Images (Max 10)
            </h4>
            <div className="d-flex ac-js gap-3 flex-wrap">
              <div className="position-relative">
                <button
                  className={"cust-btn recep-yes mt-3 mb-3"}
                  onClick={() => imgRef.current?.[ind]?.click()}
                >
                  Upload
                </button>
                <input
                  type="file"
                  className="input-pop mt-2 w-100 d-none"
                  accept="image/*"
                  // onChange={handleImages}
                  onChange={(e) => handleChange(e, ind, "images")}
                  multiple={true}
                  ref={(el) => (imgRef.current[ind] = el)}
                  disabled={images.length >= 10} // Disable input if 10 images are already selected
                />
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {item?.images?.map((itemImg, indImg) => (
                    <div
                      key={indImg}
                      className="position-relative"
                      draggable
                      onDragStart={(e) => handleDragStart(e, ind, indImg)}
                      onDragOver={(e) => handleDragOver(e, ind, indImg)}
                      onDrop={(e) => handleDrop(e, ind, indImg)}
                      onDragEnd={handleDragEnd}
                      style={{
                        opacity: draggedItem?.roomIndex === ind && draggedItem?.imageIndex === indImg ? 0.5 : 1,
                        cursor: 'move'
                      }}
                    >
                      <img
                        src={itemImg?.name ? URL.createObjectURL(itemImg) : itemImg}
                        style={{
                          height: "100px",
                          width: "100px",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => showImgPopup(itemImg)}
                        alt=""
                      />
                      <CancelIcon
                        className="red pointer"
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-7px",
                          width: "20px",
                        }}
                        onClick={() => newRoomRemoveImage(ind, indImg)}
                      />
                    </div>
                  ))}

                </div>
              </div>
              {popup && (
                <div className="img-popup-design">
                  <div className="img-popup">
                    <div
                      className="d-flex ac-je pointer"
                      onClick={() => {
                        setPopup(false);
                        setImage("");
                      }}
                    >
                      <CancelIcon />
                    </div>
                    <div style={{ width: "350px" }}>
                      <img
                        src={image?.name ? URL.createObjectURL(image) : image}
                        alt=""
                        className="w-100 mt-3"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
      <div className="d-flex ac-jb mt-5">
        <button
          className={
            "cust-btn btn_new text-nowrap  f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
          }
          onClick={() => addNewRoom()}
        >
          Add Room
        </button>
        <button
          className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
          onClick={() => addRoomsFunc()}
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm"></div>
          ) : (
            "Submit"
          )}
        </button>

      </div>
    </div>
  );
};

export default PropertyRoomsAdd;